import { callApiWithAuthorization } from "../CallApi";

export async function getAliceRecommendedEntities(domain, description, model, entitiesToSkip, workItemInformation, language="en", skipAuth = false) {
    const request = await callApiWithAuthorization("/api/v0/alicegpt/entities?language=" + language, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Skip-Authorization": skipAuth
        },
        body: JSON.stringify({
            numberOfEntities: 10,
            domain,
            description,
            model,
            entitiesToSkip,
            workItemInformation 
        })
    });
    const response = await request.json();
    return response;
}

export async function getAliceRecommendedAttributes(entityName, model, attributesToSkip, domain, description, workItemInformation, language="en", skipAuth) {
    const request = await callApiWithAuthorization("/api/v0/alicegpt/attribute?language=" + language, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Skip-Authorization": skipAuth
        },
        body: JSON.stringify({
            numberOfAttributes: 10,
            entityName,
            model,
            attributesToSkip,
            domain,
            description,
            workItemInformation
        })
    });
    const response = await request.json();
    return response;
}

export async function getAliceRecommendedRelations(entityNames, description, model, skipAuth = false) {
    const request = await callApiWithAuthorization("/api/v0/alicegpt/relations", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Skip-Authorization": skipAuth
        },
        body: JSON.stringify({
            entityNames,
            description,
            model
        })
    });
    const response = await request.json();
    return response;
}

export async function importSelectedDataByAlice(organizationId, projectId, entities, relations) {
    const request = await callApiWithAuthorization("/api/v0/alicegpt/import", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            organizationId,
            projectId,
            entities,
            relations
        })
    });
    const response = await request.json();
    return response;
}

export async function getAliceRecommendedReferenceAttributeForRelation(fromEntity, toEntity) {
    const request = await callApiWithAuthorization("/api/v0/alicegpt/reference-attribute", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            fromEntity, toEntity
        })
    });
    const response = await request.text();
    return response;
}

export async function importEntityAndAttributeInProject(subscriptionId, organizationId, projectId, entities) {
    const request = await callApiWithAuthorization("/api/v0/alicegpt/project/import/entity", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            subscriptionId,
            organizationId,
            projectId,
            entities
        })
    });
    const response = await request.json();
    return response;
}

export async function importAttributeInEntity(subscriptionId, projectId, entityId, attributes) {
    const request = await callApiWithAuthorization("/api/v0/alicegpt/project/import/attribute", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            subscriptionId,
            projectId,
            entityId,
            attributes
        })
    });
    const response = await request.json();
    return response;
}

export async function importRelationInProject(organizationId, projectId, relations) {
    const request = await callApiWithAuthorization("/api/v0/alicegpt/project/import/relation", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            organizationId,
            projectId,
            relations
        })
    });
    const response = await request.json();
    return response;
}

export async function getEntityMenuAndPageConfiguration(entities, maxPortals = 1, language = "en") {
    const request = await callApiWithAuthorization(
        "/api/v0/alicegpt/entity-menu-page-configuration",
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                entities,
                maxPortals,
                language
            })
        }
    );
    const response = await request.json();
    return response;
}

export async function getEntityPagesConfigurations(entities) {
    const request = await callApiWithAuthorization(
        "/api/v0/alicegpt/entity-page-configurations",
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                entities
            })
        }
    );
    const response = await request.json();
    return response;
}

export async function optimizeDisplayUsingAI(projectId) {
    const request = await callApiWithAuthorization(
        "/api/v0/project/"+projectId+"/display/optimize-using-ai",
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                projectId
            })
        }
    );
    const response = await request.json();
    return response;
}

export async function getRoleRecommendation(entities, maxRoles, description) {
    const request = await callApiWithAuthorization(
        "/api/v0/alicegpt/role-recommendation",
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                entities,
                maxRoles,
                description
            })
        }
    );
    const response = await request.json();
    return response;
}

export async function getRoleEntityAccess(roleName, entities, description) {
    const request = await callApiWithAuthorization("/api/v0/alicegpt/role-entity-access", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            roleName,
            entities,
            description
        })
    });
    const response = await request.json();
    return response;
}

export async function digestWorkItemsFile(fileUrl) {
    const request = await callApiWithAuthorization("/api/v0/integrations/digest-work-items-file", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Skip-Authorization": true
        },
        body: JSON.stringify({
            fileUrl
        })
    });
    const response = await request.json();
    return response;
}
